/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPNATUREOFPERSON = {
    ClosedCorporation: 'CC',
    CorporateEstateOrLiquidation: 'CE',
    ForeignListedCompany: 'FLC',
    ForeignStateOwnedEnterprise: 'FSOE',
    ForeignUnlistedCompany: 'FUC',
    ListedCompany: 'LC',
    OtherCompany: 'OC',
    RetirementFund: 'RF',
    StateOwnedEnterprise: 'SOE',
    UnlistedCompany: 'UC',
    Individual: 'I',
    AsylumSeeker: 'AS',
    Refugee: 'R',
    ForeignIndividual: 'FI',
    IndividualEstates: 'IE',
    AssociationNotForGain: 'ANFG',
    ChurchOrReligiousOrganisation: 'CRO',
    Club: 'C',
    SchoolOrUniversity: 'SSU',
    Society: 'SO',
    Stokvel: 'STO',
    UnincorporatedBodyOfPersons: 'UBOP',
    Trust: 'T',
    TestamentaryTrust: 'TT',
    SpecialTrustA1: 'ST1',
    SpecialTrustA2: 'ST2',
    ForeignTrust: 'FT'
} as const;
export type IAPNATUREOFPERSON = typeof IAPNATUREOFPERSON[keyof typeof IAPNATUREOFPERSON];


export function IAPNATUREOFPERSONFromJSON(json: any): IAPNATUREOFPERSON {
    return IAPNATUREOFPERSONFromJSONTyped(json, false);
}

export function IAPNATUREOFPERSONFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPNATUREOFPERSON {
    return json as IAPNATUREOFPERSON;
}

export function IAPNATUREOFPERSONToJSON(value?: IAPNATUREOFPERSON | null): any {
    return value as any;
}

